import { render } from "./Catering.vue?vue&type=template&id=2cf0cf28&scoped=true"
import script from "./Catering.vue?vue&type=script&lang=js"
export * from "./Catering.vue?vue&type=script&lang=js"

import "./Catering.vue?vue&type=style&index=0&id=2cf0cf28&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/bmu-website/bmu-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf0cf28"]])

export default __exports__